import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusPassApplicationComponent } from './components/bus-pass-application/bus-pass-application.component';
import { FormsModule } from '@angular/forms';
import { ClickOutsideModule } from '../../directives/clickOutside';
import { BusRouteComponent } from './components/bus-route/bus-route.component';

@NgModule({
  declarations: [BusPassApplicationComponent, BusRouteComponent],
  imports: [
    CommonModule,
    FormsModule,
    ClickOutsideModule
  ]
})
export class BusPassApplicationModule { }
